module.exports = __webpack_public_path__ + "static/media/Amaterasu.6bb834bc.png";